const ErrorLevel = require('@/lib/Errors/ErrorLevel');

const classes = [];
classes[ErrorLevel.ERROR] = 'danger';
classes[ErrorLevel.WARNING] = 'warning';
classes[ErrorLevel.INFO] = 'info';

/**
 * Return a CSS class to represent an error level.
 *
 * @param {number} errorLevel
 *
 * @return {string}
 */
const classForErrorLevel = (errorLevel) => classes[errorLevel] || 'danger';

module.exports = classForErrorLevel;
